import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { Link } from "react-router-dom";

export default function Dashboard() {
  const { user, logout } = useContext(AuthContext);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-purple-100/40 via-pink-100/30 to-blue-100/30 backdrop-blur-md px-4">
      <div className="bg-white/20 backdrop-blur-xl shadow-2xl rounded-2xl p-8 w-full max-w-4xl border border-white/30">
        
        {/* Avatar + Welcome */}
        <div className="flex flex-col items-center text-center">
          <img
            src={user?.avatar || "https://i.pravatar.cc/120"}
            alt="User Avatar"
            className="w-28 h-28 rounded-full border-4 border-white shadow-md object-cover"
          />
          <h1 className="text-3xl font-bold text-gray-900 mt-4">
            Welcome, {user?.name || "User"}
          </h1>
          <p className="text-gray-700 mt-2">{user?.email}</p>
        </div>

        {/* Action Buttons */}
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          <Link
            to="/solve"
            className="bg-blue-600/80 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition text-center shadow-md"
          >
            Solve DSA Question
          </Link>

          {user?.role === "Admin" && (
            <Link
              to="/admin"
              className="bg-green-600/80 text-white py-3 rounded-lg font-semibold hover:bg-green-700 transition text-center shadow-md"
            >
              Admin Panel
            </Link>
          )}

          <Link
            to="/profile"
            className="bg-purple-600/80 text-white py-3 rounded-lg font-semibold hover:bg-purple-700 transition text-center shadow-md"
          >
            My Profile
          </Link>

          <button
            onClick={logout}
            className="bg-red-600/80 text-white py-3 rounded-lg font-semibold hover:bg-red-700 transition shadow-md"
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}

